module.exports = __webpack_public_path__ + "static/img/news8.6d0b92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news8.png
// module id = EWMx
// module chunks = 52